import { cloneDeep } from 'lodash-es';
export const createGameStateSlice = ({ initialGameState })=>(set, get)=>({
            gameState: cloneDeep(initialGameState),
            setGameState: (gameState, keysInDiff)=>{
                const newGameState = {
                    ...get().gameState
                };
                for (const key of keysInDiff){
                    newGameState[key] = {
                        ...gameState[key]
                    };
                }
                set({
                    gameState: newGameState
                });
            }
        });
